import { connect } from 'react-redux'
import * as action from '../../state/task-detail/action'
import * as selector from '../../state/task-detail/selector'
import TaskOverviewWidget from './TaskOverviewWidget'
import { selectHasRole, selectIsPartner, selectUserId } from '../../../security/state/auth/selector'
import Globals from '../../../globals'
import { ROLE_TASK_ADMIN } from '../../../security/state/auth/const'
import { selectUserWithRoleList } from '../../../globals/state/selector'
import * as treatmentSelector from '../../../treatment/state/plan/selector'

const mapStateToProps = (state, props) => {
    return {
        treatmentPlan: treatmentSelector.selectTreatmentPlan(state),
        processInstance: selector.selectProcessInstance(state),
        processInstanceId: selector.selectProcessInstanceId(state),
        currentState: selector.selectCurrentState(state),
        role: selector.selectRole(state),
        isTaskAdmin: selectHasRole(state, ROLE_TASK_ADMIN),
        userId: selectUserId(state),
        assignedToUser: Globals.selector.selectUserDisplayNameById(state, props.task.assignedToUserId),
        userWithRoleForTask: selectUserWithRoleList(state, props.task.role),
        availableTransitionList: selector.selectAvailableTransitionList(state),
        processFlowVisible: selector.selectProcessFlowVisible(state),
        isPartner: selectIsPartner(state),
        onyxId: selector.selectOnyxId(state),
        onyxServer: selector.selectOnyxServer(state)
    }
}

const mapDispatchToProps = {
    changeTaskDueDate: action.changeTaskDueDate,
    changeTaskStatus: action.changeTaskStatus,
    claimTask: action.claimTask,
    unClaimTask: action.unClaimTask,
    changeAssignedTo: action.changeAssignedTo,
    updateAssignedToUserId: action.updateAssignedToUserId,
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskOverviewWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TaskOverviewWidgetContainer.js